import { render, staticRenderFns } from "./cardDepartmentClinicalTrials.vue?vue&type=template&id=f6110a7a&scoped=true"
import script from "./cardDepartmentClinicalTrials.vue?vue&type=script&lang=js"
export * from "./cardDepartmentClinicalTrials.vue?vue&type=script&lang=js"
import style0 from "./cardDepartmentClinicalTrials.vue?vue&type=style&index=0&id=f6110a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6110a7a",
  null
  
)

export default component.exports